import { ReactNode } from 'react';
import { parameterize } from 'inflected';
import { Badge } from '@Components/Badge';
import { Design, Size } from '@Components/designConstants';
import { Checkbox } from '@Components/FormCheck';
import { FilterSection } from './FilterSection';

interface CheckFilterSectionProps<T extends string> {
  label: string;
  options: { label: string; value: T }[];
  isChecked: (value: T) => boolean;
  onToggle: (value: T) => void;
  // Optional per-option counts (defaults to 0 for absent keys). When supplied, a neutral badge
  // renders on the right of each row.
  counts?: Partial<Record<T, number>>;
}

export const CheckFilterSection = <T extends string>({
  label,
  options,
  isChecked,
  onToggle,
  counts
}: CheckFilterSectionProps<T>): ReactNode => (
  <FilterSection label={label}>
    {options.map(({ label: optLabel, value }) => (
      <div key={value} className='activity-feed-check-count-row'>
        <Checkbox
          id={parameterize(`${label}-${value}`)}
          label={optLabel}
          checked={isChecked(value)}
          onChange={() => onToggle(value)}
        />
        {counts && (
          <Badge size={Size.SM} design={Design.NEUTRAL}>
            {counts[value] ?? 0}
          </Badge>
        )}
      </div>
    ))}
  </FilterSection>
);
